export function initInterviewAccordion(): void {
  const toggle = document.querySelector<HTMLButtonElement>(
    ".js-breezy-goal-2026-interview-toggle"
  );
  const body = document.querySelector<HTMLElement>(
    ".js-breezy-goal-2026-interview-expand"
  );

  if (!toggle || !body) return;

  const label = toggle.querySelector("span");

  toggle.addEventListener("click", () => {
    const isExpanded = body.classList.toggle("is-expanded");
    toggle.classList.toggle("is-expanded", isExpanded);
    toggle.setAttribute("aria-expanded", String(isExpanded));
    body.style.maxHeight = isExpanded ? `${body.scrollHeight}px` : "";
    if (label) label.textContent = isExpanded ? "close" : "more";
  });
}
